import { signal } from '@preact/signals-react'

export const profileDeviceSchemaSignal = signal({})
export const profileDeviceSchemaLoadedSignal = signal(false)
export const profileDeviceSchemaErrorSignal = signal(null)